// @flow

import type { CustomerConfig } from '@chatchamp/chatchamp-types/lib'

import { logger, getQuery } from '../../common'
import { getCustomerConfig } from '../../common/api/chatchampApi'

import { WelcomeMessage, mergeWebsiteChatConfig } from '../models'
import { Channel } from '../../main/models'

import type { RootState, WidgetTab } from './rootState'

type ActionParams = {
  commit: any,
  state: RootState,
  getters: any,
  dispatch: any
}

export const actions = {
  async loadConfig ({ commit, state, dispatch }: ActionParams) {
    const config: CustomerConfig = await getCustomerConfig(state.customerId, state.subscriberId, `referrer=${state.parentUrl}`)
    const websiteChatConfig = mergeWebsiteChatConfig(config.chatBubble, state.customWebsiteChatConfig)
    logger.info(`Received config ${JSON.stringify(config)}.`)

    if (state.customWebsiteChatConfig) logger.info(`Merged custom website chat config ${JSON.stringify(state.customWebsiteChatConfig)}.`)

    commit('setChannel', new Channel(websiteChatConfig))
    commit('setWelcomeMessages', config.chatBubble.welcomeMessages?.map(wm => new WelcomeMessage(wm)))
    commit('setChatbotPayload', getQuery('chatbotPayload'))
    dispatch('pickWelcomeMessage')
  },
  setCurrentTab ({ commit }: ActionParams, tab: WidgetTab): void {
    commit('setCurrentTab', tab)
  }
}
